// Le sezioni sono SEMPRE memorizzate in mm² internamente.
// La conversione in AWG avviene esclusivamente a livello di UI/export.
// Di conseguenza qui non serve più alcuna mappatura AWG→metrico: il valore
// in ingresso è già il valore metrico effettivo.

export const getEffectiveSectionValue = (sectionValue) => {
  const numericValue = parseFloat(sectionValue);
  return Number.isNaN(numericValue) ? sectionValue : numericValue;
};

export const normalizeSectionForComparison = (sectionValue) => {
  const numericValue = parseFloat(sectionValue);
  return Number.isNaN(numericValue) ? 0 : numericValue;
};
